import {useMutation, useQuery, useQueryClient} from "react-query";
import {
    blueprintCategory, cpx,
    createTeFromSf,
    demoEnv,
    pillars,
    updateTeFromSf,
    userDetails
} from "../../../../../../../utils/const/query-key";
import apiService from "../../../../../../../api/apiService";
import styled from "styled-components";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import FilterSearch from "./FilterSearch";
import BluePrint from "./BluePrint";
import Box from "@mui/material/Box";
import {
    PILLARS_AMOUNT,
    usercenterUser
} from "../../../../../../../utils/const/createEnvConsts";
import StepperContext from "../StepperContext";
import React, {useContext, useEffect, useState} from "react";
import EnvironmentContext from "../../EnvironmentContext";
import TechnicalEngagementContext from "../../TechnicalEngagementContext";
import {useNavigate} from "react-router-dom";
import moment from "moment";
import ModalContext from "../../../../envResultsTable/ModalContext";
import Loading from "../../../../../Loading";
import {getEnvironmentURL} from "../../EnvironmentUtils";
import {TechnicalEngagementLinkUtil} from "../../../../envResultsTable/TechnicalEngagementLinkUtil";
import { useLocation } from "react-router-dom";

const CardBpCategory = styled(Tab)`
  width: 100px;
  height: 36px;
  background: var(--color-workspace-bg-page-area);
  border: 1px solid #D9D9D9;
  cursor: pointer;
  list-style: none;
  display: flex;
  justify-content: center;
  align-items: center;

`;

export const TabsStyled = styled(Tabs)`
  .selected {
    color: var(--color-brand-pink-primary);
    border-color: var(--color-brand-pink-primary);
    background-color: var(--color-brand-pink-light-selected);
    outline: none;
  }
`;

const BpCategoryContainer = styled(TabList)`
  display: flex;
  padding: 0px;
  position: absolute
`;

const Button = styled.button`

  width: 75px;
  height: 36px;
  background: var(--color-workspace-bg-page-area);
  border: 1px solid var(--color-createenv-form-btn-border);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: var(--color-table-even);
    color: var(--color-brand-pink-primary);
  }

  &.next {
    background: var(--unnamed-color-ec407a);
    background: var(--color-brand-pink-primary);
    color: var(--color-workspace-bg-page-area);
    border-radius: 2px;
    margin-right: 17px;

    ${props => props.disabled ? 'pointer-events: none;' : ''}
    ${props => props.disabled ? 'background: var(--unnamed-color-ec407a) ;' : ''}
    ${props => props.disabled ? 'background: #f1d8df;' : ''}
    &:hover {
      background: var(--color-createenv-stepper-next-btn-bg-hover);
    }
  }
`;

const ScrollBlueprintDiv = styled.ul`
  width: 520px;
  height: 350px;
  overflow: auto;
  margin-bottom: 20px;
  padding: 0px;

  &::-webkit-scrollbar {
    width: 12px;
    border-radius: 4px;
    background: #EFEFEF;
  }

  &::-webkit-scrollbar-thumb {
    background: #838383;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #777676;
  }
`;

const StepContainer = styled.div`
  display: flex;
`;

const BluePrintCategoriesRow = (props) => {
    const bluePrints = props.bpData;
    const navigate = useNavigate();
    const [search, setSearch] = useState("");
    const [environmentData, setEnvironmentData] = useState("");
    const [isStaticEnv, setIsStaticEnv] = useState(false);
    const queryClient = useQueryClient();
    const userData = queryClient.getQueryData(userDetails);
    const {activeStep, handleNext, handleBack} = useContext(StepperContext);
    const {environment, setEnvironment} = useContext(EnvironmentContext);
    const [selectedTabIndex, setSelectedTabIndex] = useState(1);
    const [selectedBlueprintId, setSelectedBlueprintId] = useState(null);
    const location = useLocation();

    const [filter, setFilter] = useState("");


    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const blueprintIdFromUrl = Number(params.get("blueprintId"));
        const blueprint = bluePrints?.find(
            bp => bp.id === blueprintIdFromUrl && !bp.disabledForUser
        );
        setSelectedBlueprintId(blueprint ? blueprintIdFromUrl : null);

        if (blueprint) {
            setEnvironment(prevState => ({
                ...prevState,
                blueprint_id: blueprint.id,
                category: blueprint.category,
            }));
        }
    }, [location.search, bluePrints]);

    const onClickHandle = (name) => {
        setFilter(name);
    }; const {technicalEngagement, setTechnicalEngagement} = useContext(TechnicalEngagementContext);
    const {
        contentMessage,
        setBasicModalIsOpen,
        setEnvUrl,
        setContentMessage,
        setFailedSalesForceModalIsOpen,
        setIsInvitation
    } = useContext(ModalContext);
    const {data: blueprintCategoryData} = useQuery(blueprintCategory, () =>
            apiService.getBlueprintCategoryData(),
        {staleTime: Infinity}
    );
    const {data: pillarsData} = useQuery(pillars, () =>
        apiService.getPillars()
    );
    const {
        refetch: refetchCreateTechnicalEngagement,
        isFetching: isFetchingCreateTechnicalEngagment
    } = useQuery(createTeFromSf, () =>
            apiService.createTechnicalEngagement(technicalEngagement),
        {enabled: false}
    );
    const {
        refetch: refetchUpdateTechnicalEngagement,
        isFetching: isFetchingUpdateTechnicalEngagement
    } = useQuery(updateTeFromSf, () =>
            apiService.updateTechnicalEngagement(technicalEngagement),
        {enabled: false}
    );
    const {data: isCpx} = useQuery(cpx, () =>
            true
        , {staleTime: Infinity}
    );
    const {mutate: createEnv, isLoading} = useMutation((environment) => apiService.createEnvironment(environment),
        {
            onSuccess: (data) => {
                setEnvironmentData(data);
                if (data.status === null) { // that means that the request is ok
                    queryClient.invalidateQueries(demoEnv);
                    const environmentLink = getEnvironmentURL(data);
                    setEnvUrl(environmentLink);
                    if (data.cloudType === "STATIC") {
                        setIsStaticEnv(true);
                    }
                    if (technicalEngagement.accountName !== "") {
                        setTechnicalEngagement(prevState => {
                            return {
                                ...prevState,
                                dueDate: moment(data.createdOn).format("YYYY-MM-DD"),
                                environmentId: data.id,
                                subject: technicalEngagement.technicalEngagementId === null ? "DemoPoint Auto Generated " + moment(data.createdOn).format("YYYY-MM-DD") : null
                            }
                        })
                    } else {
                        if (data.inviteCustomer) {
                            setIsInvitation(true)
                            setContentMessage(["Your Demo Environment has been created successfully and shared with " + data.customerEmail]);
                            setBasicModalIsOpen(true);
                        } else if (data.cloudType === "STATIC") {
                            setContentMessage([, , data.blueprint, data.message, data.cloudType, true]);
                            setBasicModalIsOpen(true);
                        } else {
                            setContentMessage(["Your Demo Environment has been created successfully"]);
                            setBasicModalIsOpen(true);
                        }
                    }
                } else {
                    setContentMessage(["Failed to create DemoPoint Environment, Please Try Again Later"]);
                    setBasicModalIsOpen(true);
                }
            },
        }
    );

    // use the blueprintId from the url to set the selected blueprint
    const validBlueprintCategory = blueprintCategoryData?.filter(bp => bp.isvalid);
    const validBlueprintCategoryNames = validBlueprintCategory?.map(bp => bp.name);

    const didSetInitialTab = React.useRef(false);

    useEffect(() => {
        if (!didSetInitialTab.current && validBlueprintCategoryNames) {
            const params = new URLSearchParams(location.search);
            const categoryFromUrl = params.get("category");
            if (categoryFromUrl) {
                const idx = validBlueprintCategoryNames.findIndex(
                    name => name.toLowerCase() === categoryFromUrl.toLowerCase()
                );
                if (idx !== -1) {
                    setSelectedTabIndex(idx+1);
                }
            }else{
                setSelectedTabIndex(0);
            }
            didSetInitialTab.current = true;
        }
    }, [validBlueprintCategoryNames]);

    useEffect(() => {
        let res;
        if (technicalEngagement.dueDate !== "") {
            if (technicalEngagement.technicalEngagementId !== null) {
                res = refetchUpdateTechnicalEngagement();
                res.then(result => {
                    if (result.data.ok) {
                        if (isStaticEnv) {
                            setContentMessage(["Your DemoPoint Environment has been synced successfully", <span>to SalesForce <a href={TechnicalEngagementLinkUtil(technicalEngagement)} target="_blank">#{technicalEngagement.technicalEngagementId}</a> </span>, environmentData.blueprint, environmentData.message, environmentData.cloudType, result.data.ok]);
                            setBasicModalIsOpen(true);
                        } else {
                            setContentMessage(["Your Demo Environment has been created successfully, ",<span>and synced to SalesForce Technical Engagement  <a href={TechnicalEngagementLinkUtil(technicalEngagement)} target="_blank">#{technicalEngagement.technicalEngagementId}</a></span>]);
                            setBasicModalIsOpen(true);
                        }
                    } else {
                        if (isStaticEnv) {
                            setContentMessage(["Failed to sync your demo to SalesForce Technical Engagement.", "Please try to create it manually in Salesforce", environmentData.blueprint, environmentData.message, environmentData.cloudType, result.data.success]);
                            setBasicModalIsOpen(true);
                        } else {
                            setContentMessage(["Your Demo Environment has been created successfully, ", "Failed to sync SalesForce Technical Engagement. Please try to create it manually in Salesforce"]);
                            setFailedSalesForceModalIsOpen(true);
                        }
                    }
                })
            } else {
                res = refetchCreateTechnicalEngagement();
                res.then(result => {
                    if (result.data.success) {
                        if (isStaticEnv) {
                            setContentMessage(["Your DemoPoint Environment has been synced successfully", <span>to SalesForce <a href={result.data.link} target="_blank">#{result.data.id}</a> </span>, environmentData.blueprint, environmentData.message, environmentData.cloudType, result.data.success]);
                            setBasicModalIsOpen(true);
                        } else {
                            setContentMessage(["Your Demo Environment has been created successfully ", <span>and synced to SalesForce Technical Engagement  <a href={result.data.link} target="_blank">#{result.data.id}</a></span>]);
                            setBasicModalIsOpen(true);
                        }
                    } else {
                        if (isStaticEnv) {
                            setContentMessage(["Failed to create SalesForce Technical Engagement.", "Please try to create it manually in Salesforce", environmentData.blueprint, environmentData.message, environmentData.cloudType, result.data.success]);
                            setBasicModalIsOpen(true);
                        } else {
                            setContentMessage(["Your Demo Environment has been created successfully ", "Failed to create SalesForce Technical Engagement. Please try to create it manually in Salesforce"]);
                            setFailedSalesForceModalIsOpen(true);
                        }
                    }
                })
            }
        }
    }, [technicalEngagement.dueDate]);

    useEffect(() => {
        if (contentMessage !== "") {
            navigate("/demo-point");
        }
    }, [contentMessage])

    if (isLoading || isFetchingUpdateTechnicalEngagement || isFetchingCreateTechnicalEngagment) {
        return <Loading/>
    }

    const handleBlueprintClick = (id, category, subPillar, name) => {
        setEnvironment(prevState => {
            return {
                ...prevState,
                blueprint_id: id,
                category: category,
                salesforceOpportunityID: environment.salesforceAccountID != "" ? technicalEngagement.opportunity : ""
            }
        });
        if (pillarsData.length === PILLARS_AMOUNT) {
            setTechnicalEngagement(prevState => {
                return {
                    ...prevState,
                    pillar: pillarsData?.filter(pillar => pillar.name.toLowerCase() === category.toLowerCase()).length > 0 ? category : null,
                    subPillar: subPillar,
                    blueprintName: name
                }
            })
        }
    }

    const createEnvironment = () => {
        createEnv(environment);
    }

    const matchBlueprintIcon = (category) => {
        return (validBlueprintCategory?.filter(bp => {
                if (bp.name === category) {
                    return bp;
                }
            })
        );
    }

    const filterBlueprintsByCategory = (category) => {
        let filterBp;
        if (environment.is_invitation) {
            filterBp = bluePrints?.filter(bp => {
                if (bp.userRole.id === usercenterUser) {
                    return bp;
                }
            })
        } else {
            filterBp = bluePrints;
        }
        return filterBp?.filter((bp) => {
            if (search === "") {
                return bp;
            } else if (bp.name.toLowerCase().includes(search.toLowerCase()) || bp.description.toLowerCase().includes(search.toLowerCase())) {
                return bp;
            }
        }).map(bp => {
            let bpIcon = matchBlueprintIcon(bp.category);
            return ((category === "" || category === bp.category) &&
                <BluePrint name={bp.name} description={bp.description} key={bp.id} bp={bp}
                           handleBlueprintClick={handleBlueprintClick} bpIcon={bpIcon[0]?.icon}
                           cloudTypeId={bp.cloudTypeId} userData={userData} selected={bp.id === selectedBlueprintId}/>);
        });
    }
    return (
        <div id={"blueprint-selection-step"}>
            <TabsStyled selectedTabClassName={"selected"}
                        onSelect={index => setSelectedTabIndex(index)}
                        selectedIndex={selectedTabIndex}
            >
                <BpCategoryContainer>
                    <CardBpCategory id={"blueprint_all_tab"}>
                        All
                    </CardBpCategory>
                    {validBlueprintCategory?.map(bp => {
                        return (
                            <CardBpCategory
                                key={bp.name}
                                selected={bp.name === filter}
                                onClick={() => onClickHandle(bp.name)}
                                style={bp.name === "Infinity Core Services" ? { width: '160px' } : {}}
                            >
                                <img style={{ width: 14, height: 14, margin: 2 }} src={bp.icon} alt={bp.name} />
                                <span>{bp.name}</span>
                            </CardBpCategory>
                        );
                    })}
                </BpCategoryContainer>
                <FilterSearch search={search} setSearch={setSearch}/>
                <TabPanel>
                    <ScrollBlueprintDiv>
                        {filterBlueprintsByCategory("")}
                    </ScrollBlueprintDiv>
                </TabPanel>
                {
                    validBlueprintCategoryNames?.map((category) => (
                        <TabPanel key={category}>
                            <ScrollBlueprintDiv>
                                {filterBlueprintsByCategory(category)}
                            </ScrollBlueprintDiv>
                        </TabPanel>
                    ))
                }
            </TabsStyled>
            <Box sx={{mb: 2}}>
                <StepContainer>
                    <Button
                        className={'next'}
                        sx={{mt: 1, mr: 1}}
                        disabled={environment.blueprint_id === ""}
                        onClick={createEnvironment}
                    >
                        Submit
                    </Button>
                    {environment.customer_company_name.includes("CPX") ?
                        <Button
                            id={"cancelCpxBtn"}
                            onClick={() => navigate("/demo-point")}
                            sx={{mt: 1, mr: 1}}
                        >
                            Cancel
                        </Button>
                        : <Button
                            id={"back"}
                            onClick={handleBack}
                            sx={{mt: 1, mr: 1}}
                        >
                            {activeStep === 0 ? 'Cancel' : 'Back'}
                        </Button>
                    }
                </StepContainer>
            </Box>
        </div>
    );
}

export default BluePrintCategoriesRow;
